import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { trackUserActivity } from "../api/userActivity.api";
import { notifyRewardCompletions } from "../redux/actions/backgroundProcesses";

export const MODULE_VISIT_TYPES = {
    DATA_ANALYST: "data_analyst_module_visit",
    PROFESSORU: "professoru_module_visit",
};

export const DATA_ANALYST_MILESTONES = {
    REVIEW_ANALYTICS_15: "data_analyst_review_analytics_15",
    REVIEW_ANALYTICS_30: "data_analyst_review_analytics_30",
    REVIEW_ANALYTICS_50: "data_analyst_review_analytics_50",
    REVIEW_ANALYTICS_75: "data_analyst_review_analytics_75",
    REVIEW_ANALYTICS_100: "data_analyst_review_analytics_100",
};

export const useTrackModuleVisit = (moduleActivityType, page, metadata = {}) => {
    const dispatch = useDispatch();
    const [result, setResult] = useState(null);
    const trackedRef = useRef(false);

    useEffect(() => {
        if (!moduleActivityType || trackedRef.current) return;

        trackedRef.current = true;

        const track = async () => {
            try {
                const data = await trackUserActivity(moduleActivityType, { page, ...metadata });
                if (data?.milestonesReached?.length > 0) {
                    dispatch(notifyRewardCompletions(data.milestonesReached));
                }
                setResult(data);
            } catch (error) {
                setResult({ isFirstVisit: false, visitCount: 0, milestonesReached: [] });
            }
        };

        track();
    }, [moduleActivityType]);

    return result;
};
